<template>
    <div class="uk-padding uk-background-muted">
        <div class="uk-container uk-container-small">
          <div uk-grid>

            <div class="uk-width-3-5@m">
              <div class=" " >
                <img src="../../../../public/fincor_clear.png" class="uk-align-center "  alt="">
                <p class="uk-text-small">
                  3rd Floor, Amerigo House, Elizabethan Square, <br> George Town, <br>
                  Box 31614, SMB, KY1-1207, <br> Grand Cayman, Cayman Islands <br>

                  <a href="tel:1345-746-9272">Office Phone: 345-746-9272 (345-74MYCPA)</a> <br>
                  <a href="tel:1345-325-8849" class="">Cell Phone: 345-325-8849 </a><br>
                  <a href="mailto:admin@fincor.ky">Email: admin@fincor.ky</a>
                </p>
              </div>
            </div>
            <div  class="uk-width-2-5@m">
              <img src="@/assets/IMG_9992.jpg" class="uk-border-rounded" alt="">
            </div>
          </div>

        </div>
    </div>
</template>

<script>
    export default {
        name: "ecard"
    }
</script>

<style scoped>
    /* Custom, iPhone Retina */
    @media only screen and (min-width : 320px) {
        .c_image{
            max-width: 200px;
            max-height: 200px;
            height: auto;
            width: auto;
        }
    }

    /* Extra Small Devices, Phones */
    @media only screen and (min-width : 480px) {
        .c_image{
            max-width: 250px;
            max-height: 250px;
            height: auto;
            width: auto;
        }
    }

    /* Small Devices, Tablets */
    @media only screen and (min-width : 768px) {
        .c_image{
            max-width: 400px;
            max-height: 400px;
            height: auto;
            width: auto;
        }
    }

    /* Medium Devices, Desktops */
    @media only screen and (min-width : 992px) {

    }

    /* Large Devices, Wide Screens */
    @media only screen and (min-width : 1200px) {
        .c_image{
            max-width: 600px;
            max-height: 600px;
            height: auto;
            width: auto;
        }
    }
</style>